import * as React from 'react';

import {Button} from 'shells/button/button';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {StatusBadge} from 'shells/status-badge/status-badge';

import type {User as UserFragment} from 'nutshell-graphql-types';

import {appHistory} from '../../../history';

import styles from './mount-mfa.module.css';

type Props = {
    user: UserFragment | null | undefined;
};

export function MFASetupEmptyState(props: Props) {
    return (
        <>
            {!props.user ? (
                // View as user
                <div className={styles['mfa-container']}>
                    <StackLegacy spacing={12}>
                        <span>
                            <b>Two-factor authentication</b> makes your account more secure by
                            requiring a code when you log in as well as your email and password.
                        </span>
                        <Button
                            onClick={() => {
                                appHistory.push({
                                    hash: '/connect-mfa/select-method',
                                    search: location.search,
                                });
                            }}
                            variant='text-primary'
                            size='big'
                            className={styles['two-factor-button']}
                        >
                            Enable two-factor authentication
                        </Button>
                    </StackLegacy>
                </div>
            ) : (
                // View as admin
                <StatusBadge level='info--grey' text='Not yet enabled' isInteractive={false} />
            )}
        </>
    );
}
